import { render, staticRenderFns } from "./Bolsa.vue?vue&type=template&id=5b534e3c&scoped=true&lang=pug&"
import script from "./Bolsa.vue?vue&type=script&lang=js&"
export * from "./Bolsa.vue?vue&type=script&lang=js&"
import style0 from "./Bolsa.vue?vue&type=style&index=0&id=5b534e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b534e3c",
  null
  
)

export default component.exports